import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-097f9936"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Register", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Register", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Already have an account?", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Login", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { ref, watch, nextTick, computed, inject, Ref, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { 
    FormInst, FormItemInst, FormItemRule, FormValidationError,
    FormRules, NCard, NForm, NInput, NFormItem, NSelect, NRow, NCol, NButton,
    NDynamicTags, SelectOption, NSpace, NAutoComplete, AutoCompleteInst
} from 'naive-ui'
import axios from 'axios'
import { ChoicesDto, RegistrasiModel, RegistrasiDto, CategoryModel, CityModel } from '@/types/Registrasi'
import { MessageApiInjection } from 'naive-ui/lib/message/src/MessageProvider'
import { ValidateError } from 'async-validator'
import store from '@/store'
import Brand from '@/components/Brand.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Register',
  setup(__props) {

const parameters = ["email", "password", "full_name", "username", "description", "category", "city", "cities", "categories"]
const router = useRouter()
const app = getCurrentInstance()
const message = app!.appContext.config.globalProperties.message 
const model = ref<RegistrasiModel>({
    email: null,
    password: null,
    confirmPassword: null,
    category: null,
    full_name: null,
    username: null,
    description: null,
    city: [],
    cities: [],
    categories: [],
    portfolio_url_reg: null
})

const categoryLoading = ref(true)
var categoryData: SelectOption[] = []   // Store categories data from backend
var cityData: SelectOption[] = []   // Store categories data from backend
const categoryOptions = ref<SelectOption[]>([])
const cityOptions = ref<SelectOption[]>([])

function categorySearch(query: string) {
    if (!query.length) {
        categoryOptions.value = categoryData
    } else {
        categoryLoading.value = true
        var res: SelectOption[] = categoryData.filter((item) => ~item.value.toString().toLowerCase().indexOf(query.toLowerCase()))
        categoryOptions.value = res
        categoryLoading.value = false
    }
}
function citySearch(query: string) {
    if (!query.length) {
        cityOptions.value = cityData
    } else {
        var res: SelectOption[] = cityData.filter((item) => ~item.value.toString().toLowerCase().indexOf(query.toLowerCase()))
        cityOptions.value = res
    }
}
function getRegisterOptions() {
    return axios.options('/api/auth/register/')
}
function getCategories() {
    return axios.get('/api/profile/category')
}
function getCities() {
    return axios.get('/api/profile/city')
}
axios.all([getCategories(), getCities()])
.then((results) => {
    let categoriesTemp = results[0].data
    let cityTemp = results[1].data

    cityData = cityTemp.map((el: CityModel) => {
        return {value: el.name, label: el.name}
    })
    cityOptions.value = cityTemp.map((el: CityModel) => {
        return {value: el.name, label: el.name}
    })

    categoryData = categoriesTemp.map((el: CategoryModel) => {
        return {value: el.name, label: el.name}
    })
    categoryOptions.value = categoriesTemp.map((el: CategoryModel) => {
        return {value: el.name, label: el.name}
    })
    categoryLoading.value = false    
})
.catch((error) => {
    message.error("Cannot load registration options", {showIcon: true, closable: true})
});

const form = ref<FormInst | null>(null)
const passwordFormItem = ref<FormItemInst | null>(null)
const rules: FormRules = {
    email: [
        {
            required: true,
            message: 'Email is required',
            trigger: ['change']
        },
        {
            validator (rule: FormItemRule, value: string) {
                return /\b[\w.\-+]+@[\w.-]+.\w{2,4}\b/.test(value)
            },
            message: 'Email is invalid',
            trigger: ['change']
        }
    ],
    password: [
        {
            required: true,
            message: "Password is required",
            trigger: ['change']
        },
        {
            validator (rule: FormItemRule, value: string) {
                return value.length >= 8;
            },
            message: "Password must be at least 8 characters",
            trigger: ['change']
        },
        {
            validator (rule: FormItemRule, value: string) {
                return /\d/.test(value)
            },
            message: "Password must have at least a number",
            trigger: ['change']
        },
        {
            validator (rule: FormItemRule, value: string) {
                return /[a-zA-Z]/.test(value)
            },
            message: "Password must have at least an alphabet character",
            trigger: ['change']
        },
    ],
    confirmPassword: [
        {
            required: true,
            message: 'Confirm password is required',
            trigger: ['change']
        },
        {
            validator (rule: FormItemRule, value: string): boolean {
                return value === model.value.password
            },
            message: 'Passwords are different',
            trigger: ['change', 'password-input']
        }
    ],
    username: [
        {
            required: true,
            message: 'Username is required',
            trigger: ['change']
        }
    ],
    cities: [
        {
            required: true,
            validator (rule: FormItemRule, value: string): boolean {
                return value.length > 0
            },
            message: 'At least 1 city is required',
            trigger: ['change']
        }
    ],
    categories: [
        {
            required: true,
            validator (rule: FormItemRule, value: string): boolean {
                return value.length > 0
            },
            message: 'At least 1 artist category is required',
            trigger: ['change']
        }
    ],
    portfolio_url_reg: [{
            required: true,
            message: 'URL/link to existing portfolio is required',
            trigger: ['change']
        }
    ],
}
function login() {
    axios.post('/api/auth/token/', {
        email: model.value.email,
        password: model.value.password
    })
    .then((response) => {
        registerLoading.value = false
        const token = response.data.access;
        const refresh = response.data.refresh;
        store.commit("setToken", token);
        store.commit("setRefresh", refresh);
        store.commit("setIdentity", token);

        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        router.push({name: "verify-email", params: {
            fromRegister: true
        }} as any)
        
    })
    .catch((error) => {
        registerLoading.value = false
        message.error("A problem is occurred when logging in", {showIcon: true, closable: true})
        router.push('/login')
    })
    model.value = {
        email: null,
        password: null,
        confirmPassword: null,
        category: null,
        full_name: null,
        username: null,
        description: null,
        city: [],
        cities: [],
        categories: [],
        portfolio_url_reg: null
    }
}
const registerLoading = ref(false)
function validateForm(errors: ValidateError[][] | undefined) {
    if (!errors) {
        let payload = new RegistrasiDto(model.value)
        console.log(payload)
        registerLoading.value = true

        axios.post('/api/auth/register/', payload)
        .then((response) => {
            login()
        })
        .catch((error) => {
            registerLoading.value = false
            var keys: string[] = []
            console.log(error)
            if (error.response.data != null) {
                keys = Object.getOwnPropertyNames(error.response.data)
            }
            var variableErr: string[] = []
            keys.forEach((v) => {
                if (parameters.includes(v)) {
                    error.response.data[v].forEach((element: string) => {
                        variableErr.push(element)
                    });
                }
            })
            if (variableErr.length) {
                message.error(variableErr[0], {showIcon: true, closable: true})
            } else {
                message.error("A problem is occurred during registration", {showIcon: true, closable: true})
                console.error(error)
            }
        })
    } 
}
function handleValidateButtonClick (e: MouseEvent) {
    e.preventDefault()
    form.value!.validate(validateForm).catch(error => {
        message.error('Registration form is invalid', {showIcon: true, closable: true})
    })
}

const cityAutoComplete = ref<AutoCompleteInst | null>(null)
const cityInput = ref('')


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NCard), { size: "small" }, {
      header: _withCtx(() => [
        _createVNode(_unref(NSpace), {
          id: "form-title",
          vertical: "",
          align: "center",
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(Brand, { "is-center": true }),
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(NForm), {
          ref_key: "form",
          ref: form,
          model: model.value,
          rules: rules
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NFormItem), {
              id: "emailForm",
              path: "email",
              first: "",
              label: "Email"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  id: "email",
                  value: model.value.email,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((model.value.email) = $event)),
                  onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  size: "large"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), {
              id: "artist-username-form",
              path: "username",
              label: "Username"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  id: "username",
                  value: model.value.username,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((model.value.username) = $event)),
                  onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  size: "large",
                  placeholder: "Enter your username. This will be used for the URL to your profile"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), {
              id: "passwordForm",
              path: "password",
              first: "",
              label: "Password"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  id: "password",
                  value: model.value.password,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((model.value.password) = $event)),
                  type: "password",
                  "show-password-on": "mousedown",
                  onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  size: "large"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), {
              id: "confirmPasswordForm",
              ref_key: "passwordFormItem",
              ref: passwordFormItem,
              path: "confirmPassword",
              first: "",
              label: "Confirm Password"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  id: "confirmPassword",
                  value: model.value.confirmPassword,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((model.value.confirmPassword) = $event)),
                  disabled: !model.value.password,
                  type: "password",
                  "show-password-on": "mousedown",
                  onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  size: "large"
                }, null, 8, ["value", "disabled"])
              ]),
              _: 1
            }, 512),
            _createVNode(_unref(NFormItem), {
              id: "fullNameForm",
              path: "full_name",
              first: "",
              label: "Full Name"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  id: "fullName",
                  value: model.value.full_name,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((model.value.full_name) = $event)),
                  onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  size: "large"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), {
              id: "descriptionForm",
              path: "description",
              first: "",
              label: "Description"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  id: "description",
                  value: model.value.description,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((model.value.description) = $event)),
                  onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  size: "large",
                  type: "textarea"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), {
              id: "categoryForm",
              path: "categories",
              label: "Category Artist"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NSelect), {
                  id: "categories",
                  value: model.value.categories,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((model.value.categories) = $event)),
                  options: categoryOptions.value,
                  filterable: "",
                  clearable: "",
                  multiple: "",
                  remote: "",
                  onKeydown: _cache[13] || (_cache[13] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  onSearch: categorySearch,
                  size: "large"
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), {
              id: "portfolioUrlRegForm",
              path: "portfolio_url_reg",
              first: "",
              label: "Portfolio URL"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  id: "portfolio_url_reg",
                  value: model.value.portfolio_url_reg,
                  "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((model.value.portfolio_url_reg) = $event)),
                  onKeydown: _cache[15] || (_cache[15] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  size: "small",
                  type: "textarea",
                  placeholder: "Enter the URL or link to your online portfolio, for example Instagram, Youtube or something else"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NFormItem), {
              id: "cityForm",
              path: "cities",
              label: "City"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NSelect), {
                  id: "cities",
                  value: model.value.cities,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((model.value.cities) = $event)),
                  multiple: "",
                  clearable: "",
                  filterable: "",
                  remote: "",
                  size: "large",
                  onKeydown: _cache[17] || (_cache[17] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
                  options: cityOptions.value,
                  onSearch: citySearch
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NButton), {
              id: "submitBtn",
              disabled: model.value.age === null,
              loading: registerLoading.value,
              type: "primary",
              "attr-type": "submit",
              onClick: handleValidateButtonClick,
              size: "large"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["disabled", "loading"])
          ]),
          _: 1
        }, 8, ["model"]),
        _createVNode(_unref(NSpace), {
          vertical: "",
          align: "center"
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _hoisted_5,
            _createVNode(_component_router_link, {
              class: "router-link",
              to: "/login"
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})